import AuthService from './AuthService';
import ApiService from "./ApiService";

class BasketService extends ApiService{
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = 'ru';
        this.routes = this.getServiceRoutes();
        this._listUrl = '/basket';
        this._listUrlSimple = '/basket/simple';
        this._listProducts = '/basket/products';
        this._listGuestProducts = '/basket/guest-products';
        this._deleteUrl = '/basket/delete';
        this._updateUrl = '/basket/update';
        this._orderUrl = '/order/create';
        this._orderBuyerInfo = '/basket/buyer-info';
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    createBasketOrder(credentials) {
        return this.postResource(this._orderUrl, credentials, this.getBaseHeaders());
    }

    getServiceRoutes(){
        return {
            getList: {
                path:'/basket/get-general-data',
                method: 'POST',
            }
        }
    }

    deleteProduct(id) {
        const params = {productId: id};

        return this.postResource(this._deleteUrl, params, this.getBaseHeaders());
    }

    getList() {
        return this.postResource(this._listUrl, {}, this.getBaseHeaders());
    }

    getListSimple() {
        return this.postResource(this._listUrlSimple, {}, this.getBaseHeaders());
    }

    orderBuyerInfo() {
        return this.postResource(this._orderBuyerInfo, {}, this.getBaseHeaders());
    }

    guestProducts(IDs= []) {
        const params = {productIDs: IDs}

        return this.postResource(this._listGuestProducts, params, this.getBaseHeaders());
    }

    products() {
        return this.postResource(this._listProducts, {}, this.getBaseHeaders());
    }

    /*products = [
     *  id: Number,
     *  quantity: Number
     * ]
     */
    updateList(products) {

        const params = {products: products};

        return this.postResource(this._updateUrl, params, this._authService.getAuthHeader());
    }

    setLocale(locale) {
        this._locale = locale;
    }

    async getListGeneral(filters) {
        const url = this.routes.getList.path;

        return this._authService.getApiService().postResource(
            url,
            filters,
            this.getBaseHeaders()
        );
    }
}

const basketService = new BasketService(AuthService);

export default basketService;
